<template>
  <div class="loadScreenModal">
    <b-modal
      v-model="loadScreenModalShow"
      centered
      hide-header
      hide-footer
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc
    >
      <template v-slot:default>
        <h4 style="text-align: center !important" class="mb-0">
          <b-progress class="w-100" :max="100" height="1.5rem">
            <b-progress-bar
              :value="progress"
              :label="`${progress}%`"
              animated
            ></b-progress-bar>
          </b-progress>
          <!-- <label
            v-for="(item, key) in loadScreenMsg"
            :key="key"
            :id="'loadScreen' + key"
            class="modal-wait"
            :style="'animation-delay:' + 0.25 * key + 's'"
            >{{ item }}</label
          > -->
        </h4>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "loadScreenModal",
  data() {
    return {
      loadingTime: 0,
      progress: 0,
      reSetPercent: "",
    };
  },
  computed: {
    ...mapGetters({
      loadScreenModalShow: "loadscreenmodal/get_loadScreenModalShow",
      loadScreenMsg: "loadscreenmodal/get_loadScreenMsg",
    }),
  },
  watch: {
    loadScreenModalShow: {
      handler() {
        let vm = this;
        if (vm.loadScreenModalShow) {
          vm.progress = 0;
          clearTimeout(vm.reSetPercent);
          vm.setPercent();
        }
      },
    },
  },
  methods: {
    setPercent() {
      let vm = this;
      vm.progress += 30;
      if (vm.progress < 90) {
        vm.reSetPercent = setTimeout(function () {
          vm.setPercent();
        }, 700);
      }
    },
  },
};
</script>

<style>
.modal-backdrop {
  opacity: 0.2 !important;
}
.modal-wait {
  position: relative;
  animation-name: wave;
  animation-duration: 0.35s;
  animation-iteration-count: infinite;
}
@keyframes wave {
  0% {
    top: 0;
  }
  25% {
    top: 1.75px;
  }
  50% {
    top: 3.5px;
  }
  75% {
    top: 1.75px;
  }
  100% {
    top: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/loadScreenModal.vue